import { useTranslation } from 'react-i18next';
import { Link, Links, Meta, Scripts } from 'react-router';

import useRegion from '~/hooks/useRegion';
import Footer from '~/legacy/components/footer';

import { DynamicHeader } from './DynamicHeader';

export default function Error404() {
  const region = useRegion();
  const { t } = useTranslation('error');

  return (
    <html lang={region.lang}>
      <head>
        <title>{t('pageNotFound')}</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body>
        <DynamicHeader region={region} />
        <main>
          <div className="box-border">
            <div className="flex min-h-[66vh] items-center justify-center bg-[url('https://cms-cdn.thesolesupplier.co.uk/bolt/404.jpg')] bg-cover bg-center">
              <div className="inset-x-0 flex flex-col gap-8 text-center text-white drop-shadow-[2px_2px_rgb(0,0,0)]">
                <h1 className="text-display font-bold">404</h1>
                <p className="text-title-lg">
                  {t('thePageYouWereLookingForDoesNotSeemToExist')}
                </p>
                <Link to="/">
                  <button className="mt-4 cursor-pointer rounded-full bg-white px-6 py-2 text-sm font-semibold text-black drop-shadow-none">
                    {t('backToHome')}
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <Footer />
        </main>
      </body>
      <Scripts />
    </html>
  );
}
